// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-error {
  --g-tabs-item-gap: 20px;
  width: 100%;
  max-width: 630px;
}
.dl-dialog-error__content {
  width: 630px;
  max-width: 100%;
  max-height: 80vh;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 480px) {
  .dl-dialog-error__content {
    width: 300px;
  }
}
.dl-dialog-error__header {
  max-width: 100%;
  word-break: break-word;
}
.dl-dialog-error__loader {
  margin: auto;
}
.dl-dialog-error__button + .dl-dialog-error__button {
  margin-left: 16px;
}
.dl-dialog-error_mobile {
  padding: 0 16px;
  max-width: none;
}
.dl-dialog-error_mobile .dl-dialog-error__tab-navigation {
  margin-top: 8px;
  margin-bottom: 22px;
}
.dl-dialog-error_mobile .dl-dialog-error__button + .dl-dialog-error__button {
  margin-left: 0;
}
.dl-dialog-error_mobile .dl-dialog-error__footer-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
}
.dl-dialog-error_mobile .dl-dialog-error__loader {
  display: flex;
  justify-content: center;
  padding: 16px 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogErrorWithTabs/DialogErrorWithTabs.scss"],"names":[],"mappings":"AAAA;EAII,uBAAA;EAIA,WAAA;EACA,gBARyB;AAG7B;AAOI;EACI,YAXqB;EAYrB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AALR;AAOQ;EARJ;IASQ,YAlBkB;EAc5B;AACF;AAOI;EACI,eAAA;EACA,sBAAA;AALR;AAQI;EACI,YAAA;AANR;AASI;EACI,iBAAA;AAPR;AAUI;EACI,eAAA;EACA,eAAA;AARR;AAUQ;EACI,eAAA;EACA,mBAAA;AARZ;AAWQ;EACI,cAAA;AATZ;AAYQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;AAVZ;AAaQ;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AAXZ","sourcesContent":[".dl-dialog-error {\n  --g-tabs-item-gap: 20px;\n  width: 100%;\n  max-width: 630px;\n}\n.dl-dialog-error__content {\n  width: 630px;\n  max-width: 100%;\n  max-height: 80vh;\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 480px) {\n  .dl-dialog-error__content {\n    width: 300px;\n  }\n}\n.dl-dialog-error__header {\n  max-width: 100%;\n  word-break: break-word;\n}\n.dl-dialog-error__loader {\n  margin: auto;\n}\n.dl-dialog-error__button + .dl-dialog-error__button {\n  margin-left: 16px;\n}\n.dl-dialog-error_mobile {\n  padding: 0 16px;\n  max-width: none;\n}\n.dl-dialog-error_mobile .dl-dialog-error__tab-navigation {\n  margin-top: 8px;\n  margin-bottom: 22px;\n}\n.dl-dialog-error_mobile .dl-dialog-error__button + .dl-dialog-error__button {\n  margin-left: 0;\n}\n.dl-dialog-error_mobile .dl-dialog-error__footer-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 16px;\n}\n.dl-dialog-error_mobile .dl-dialog-error__loader {\n  display: flex;\n  justify-content: center;\n  padding: 16px 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
